<template>
    <div class="rounded-lg bg-white p-3 shadow">
        <p class="mb-4">Timeline</p>
        <draggable
            handle=".handle"
            :value="value"
            @input="data => $emit('input', data)"
            @update="updateOrder"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div v-for="(timeline, index) in value" :key="index" class="rounded-lg bg-white pt-6 pb-3 px-3 shadow mb-4 relative">

                <svg
                    @click="deleteTimeline(index)"
                    class="w-4 h-4 absolute right-4 top-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                </svg>

                <input-text
                    name="date_text"
                    label="Date Text"
                    class="mb-3"
                    v-model="timeline.date_text"
                    :error="errors.date_text ? errors.date_text[0] : null"
                    :maxlength=255
                />

                <input-text
                    name="heading"
                    label="Heading"
                    class="mb-3"
                    v-model="timeline.heading"
                    :error="errors.heading ? errors.heading[0] : null"
                    :maxlength=255
                />

                <input-rich-text
                    name="text"
                    label="Text"
                    v-model="timeline.text"
                    :error="errors.text ? errors.text[0] : null"
                    :language="language"
                />

                <media-reference
                    v-model="timeline.image"
                    :key="`media${timeline.id || timeline.key}`"
                    :language="language"
                    class="mt-3"
                    label="Image"
                />
            </div>
        </draggable>
        <Btn
            content="Add Timeline"
            class="mt-3"
            type="button"
            @click="addTimeline"
        />
    </div>
</template>

<script>
import draggable from "vuedraggable";
import {useFroalaStore} from "../stores/froala";
export default {
    name: "AboutUsTimeline",
    components: {draggable},
    props: {
        value: {
            type: Array,
            required: true,
        },
        errors: {
            type: [Array, Object],
            required: true,
        },
        language: Object,
    },
    data: function(){
        return {
            timeline: this.value,
            froalaStore: useFroalaStore(),
        }
    },
    methods: {
        addTimeline: function(){
            this.timeline.push({key: Math.random().toString(16).substr(2, 8)});
            this.updateOrder();
        },
        deleteTimeline: function(index){
            this.timeline.splice(index, 1);
            this.updateOrder();
        },
        updateOrder: function(){
            const timeline = [...this.timeline];
            this.timeline = timeline.map((timeline, index) => {
                timeline.order = index;
                return timeline;
            });
            this.$emit('input', this.timeline)
        }
    },
    watch: {
        value: function(newValue){
            this.timeline = newValue;
        }
    }
}
</script>
